module.exports = __webpack_public_path__ + "static/media/UbuntuStudio-Icons-Video_Production.4b7658bc.svg";